export const ListQueryKey = 'carousels';
export const DetailQueryKey = 'carousel';
export const Urls = {
  selectUrl: '/carousel/list',
  updateUrl: '/carousel/update',
  deleteUrl: '/carousel/delete',
  createUrl: '/carousel/create',
  detailUrl: '/carousel/detail'
};